/* global fetch */
import addBasePath from './addBasePath';


export default function (url, options = {}) {
	return fetch(addBasePath(url), Object.assign({}, {
		credentials: 'same-origin',
	}, options)).then((response) => {
		if (!(response.status >= 200 && response.status < 300)) {
			const error = new Error(response.statusText);
			error.response = response;
			throw error;
		}
		return response;
	}).then(response => response.json());
}



// WEBPACK FOOTER //
// ./js/utils/fetch.js